import { useMutation, useQuery } from "react-query"
import { Exams } from "../api/exams"
import { useState } from "react"
import { TtrainingKeyParameter } from "../shared/types/trainingKeyParameter.type"
import { TuserAccountType } from "../shared/types/user.type"
import { useSelector } from "react-redux"
import { RootState } from "../store"
import { get } from "lodash"
import { TcomputedKeyParam, TkeyParamLayout } from "../shared/types/computedKeyParam.type"
import { TsavePreselects, groupByCategory } from "../shared/utils/myTrainings"
import { toast } from "react-toastify"
import { t } from "i18next"
import { hydraTransform } from "../shared/utils/hydraTransformer"
import { useLocales } from "./useLocales"

export const useMyTrainings = (trainer?: string) => {
    const {currentLang} = useLocales()
    const getPreselects = useMutation(({ type, nationality }: { type: TuserAccountType, nationality: string }) => Exams.getPreselects(type, nationality))
    const deletePreselects = useMutation(() => Exams.deletePreselects(trainer))
    const savePreselects = useMutation((data: TsavePreselects[]) => Exams.savePreselects(data))
    const getTrainingsKeyParams = useQuery(['keyParams'], () => Exams.getKeyParams(currentLang))

    const saveKeyParams = async (data: TsavePreselects[]) => {
        try {
            await deletePreselects.mutateAsync()
            await savePreselects.mutateAsync(data)
            toast(t('layout:updateSuccess'), { type: 'success' })

        } catch (err) {
            toast(t('error:generic'), { type: 'error' })

        }
    }




    return {
        trainingKeys: (getTrainingsKeyParams.data?.data || {}) as TtrainingKeyParameter,
        getPreselects,
        groupedTrainingKeys: groupByCategory((getTrainingsKeyParams.data?.data || {}) as TtrainingKeyParameter),
        isSavingPreselects: deletePreselects.isLoading || savePreselects.isLoading,
        trainingKeysLoading: getTrainingsKeyParams.isLoading,
        saveKeyParams
    }
}